import getCustomNodes from './getCustomNodes';

const getTitle = (preTag) => ({
  object: 'block',
  type: `${preTag}_title`,
  nodes: [
    {
      object: 'text',
      leaves: [
        {
          text: '',
        },
      ],
    },
  ],
});

const getDate = (preTag) => ({
  object: 'block',
  type: preTag,
  data: {
    dateInput: null,
  },
  nodes: [
    {
      object: 'text',
      leaves: [
        {
          text: '',
        },
      ],
    },
  ],
});

export const getContentEditableDiv1 = (preTag) => ({
  object: 'block',
  type: preTag,
  nodes: [
    {
      object: 'block',
      type: 'paragraph',
      nodes: [
        {
          object: 'text',
          leaves: [
            {
              text: '',
            },
          ],
        },
      ],
    },
  ],
});

export const getContentEditableDiv2 = (preTag) => ({
  object: 'block',
  type: preTag,
  nodes: [
    {
      object: 'block',
      type: 'unordered_list',
      nodes: [
        {
          object: 'block',
          type: 'list_item',
          nodes: [
            {
              object: 'block',
              type: 'paragraph',
              nodes: [
                {
                  object: 'text',
                  leaves: [
                    {
                      text: '',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const getScore = (preTag) => ({
  object: 'block',
  type: preTag,
  nodes: [
    {
      object: 'block',
      type: `${preTag}_min`,
      nodes: [
        {
          object: 'text',
          leaves: [
            {
              text: '',
            },
          ],
        },
      ],
    },
    {
      object: 'block',
      type: `${preTag}_max`,
      nodes: [
        {
          object: 'text',
          leaves: [
            {
              text: '',
            },
          ],
        },
      ],
    },
  ],
});

export default (params) => {
  const { preTag, universityPlan } = params;

  /**
   * Conditionally build role details nodes as there might be few fields not required
   *
   * * NOTE:  If required construct new functions to generate nodes
   */
  let nodes;
  if (preTag === 'work_experience') {
    const defaultNodes = [
      getTitle(`${preTag}_job`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getContentEditableDiv2(`${preTag}_role_description`),
      getContentEditableDiv2(`${preTag}_role_achievements`),
    ];

    nodes = getCustomNodes({
      universityPlan,
      defaultNodes,
      sectionKey: 'workExperience',
    });
  } else if (preTag === 'education') {
    const defaultNodes = [
      getTitle(`${preTag}_degree`),
      getScore(`${preTag}_cgpa`),
      getTitle(`${preTag}_field`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getContentEditableDiv2(`${preTag}_role_description`),
    ];
    nodes = getCustomNodes({
      universityPlan,
      defaultNodes,
      sectionKey: 'education',
    });
  } else if (preTag === 'awards_and_honors') {
    nodes = [
      getTitle(`${preTag}_award`),
      getDate(`${preTag}_issue_date`),
      getContentEditableDiv2(`${preTag}_award_description`),
    ];
  } else if (preTag === 'volunteer_work') {
    const defaultNodes = [
      getTitle(`${preTag}_role`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getTitle(`${preTag}_cause`),
      getContentEditableDiv2(`${preTag}_role_description`),
    ];
    nodes = getCustomNodes({
      universityPlan,
      defaultNodes,
      sectionKey: 'volunteerWork',
    });
  } else if (preTag === 'certifications') {
    nodes = [
      getTitle(`${preTag}_certification`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getContentEditableDiv2(`${preTag}_certification_description`),
    ];
  } else if (preTag === 'projects') {
    nodes = [
      getTitle(`${preTag}_project`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getTitle(`${preTag}_url`),
      getContentEditableDiv2(`${preTag}_project_description`),
    ];
  } else if (preTag === 'research_experience') {
    nodes = [
      getTitle(`${preTag}_title`),
      getTitle(`${preTag}_research`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getTitle(`${preTag}_url`),
      getContentEditableDiv2(`${preTag}_research_description`),
    ];
  } else if (preTag === 'leadership') {
    nodes = [
      getTitle(`${preTag}_role`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getTitle(`${preTag}_url`),
      getContentEditableDiv2(`${preTag}_role_description`),
    ];
  } else if (preTag === 'associations') {
    nodes = [
      getTitle(`${preTag}_association`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getTitle(`${preTag}_url`),
      getContentEditableDiv2(`${preTag}_association_description`),
    ];
  } else if (preTag === 'extra_curricular') {
    nodes = [
      getTitle(`${preTag}_activity`),
      getDate(`${preTag}_from`),
      getDate(`${preTag}_to`),
      getTitle(`${preTag}_url`),
      getContentEditableDiv2(`${preTag}_activity_description`),
    ];
  } else if (preTag === 'courses') {
    nodes = [
      getTitle(`${preTag}_course`),
      getDate(`${preTag}_completion_date`),
      getContentEditableDiv2(`${preTag}_course_description`),
    ];
  } else if (preTag === 'conferences') {
    nodes = [
      getTitle(`${preTag}_conference`),
      getDate(`${preTag}_date`),
      getContentEditableDiv2(`${preTag}_conference_description`),
    ];
  } else if (preTag === 'references') {
    nodes = [
      getTitle(`${preTag}_reference_name`),
      getTitle(`${preTag}_reference`),
      getTitle(`${preTag}_reference_email`),
    ];
  } else if (preTag === 'patents') {
    nodes = [
      getTitle(`${preTag}_patent`),
      getTitle(`${preTag}_patent_id`),
      getTitle(`${preTag}_patent_status`),
      getTitle(`${preTag}_patent_country`),
      getDate(`${preTag}_patent_date`),
      getTitle(`${preTag}_patent_url`),
      getContentEditableDiv2(`${preTag}_patent_description`),
    ];
  } else if (preTag === 'test_scores') {
    nodes = [
      getTitle(`${preTag}_test`),
      getDate(`${preTag}_date`),
      getScore(`${preTag}_cgpa`),
      getContentEditableDiv2(`${preTag}_test_description`),
    ];
  } else if (preTag === 'skill') {
    nodes = [getTitle(preTag)];
  }

  return nodes;
};
